import cxs from 'cxs';

export const USER_DETAILS_CONTAINER = cxs({
  display: 'flex',
  width: '33%',
  alignItems: 'center',
  justifyContent: 'center',

  ' > .image': {
    marginRight: '20px'
  }
});

export const CONTAINER = cxs({
  flex: 1
});